
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FeatherIcon from 'feather-icons-react';
import ReCAPTCHA from "react-google-recaptcha";
import { useRef, useState } from 'react';
import { FormInput } from 'components/form';
import { EnquiryDemoDetails } from 'helpers/api/ContactServices1';
import { toast } from 'react-toastify';
import { colors } from 'styles/colors';

type ContactFormProps = {
    onFormFinish?: () => void;
}

const ContactForm = ({ onFormFinish }: ContactFormProps) => {
    const [captchaStatus, setCaptchaStatus] = useState(false)
    const [captchaToken, setToken] = useState('')
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const schemaResolver = yupResolver(
        yup.object().shape({
            ComName: yup.string().required('Company name is required'),
            fname: yup.string().required('First name is required'),
            lname: yup.string().required('Last name is required'),
            Cnumber: yup.string()
                .required('Contact number is required')
                .matches(/^[0-9]+$/, 'Must be only digits')
                .min(10, 'Must be exactly 10 digits')
                .max(10, 'Must be exactly 10 digits'),
            email: yup.string().required('Email is required').email('Please enter a valid email'),
            message: yup.string().required('Message is required'),
        })
    );

    const methods = useForm({ resolver: schemaResolver });
    const { handleSubmit, register, control, formState: { errors }, reset } = methods;

    const recaptchaRef = useRef<ReCAPTCHA | null>(null);

    const onSubmit = async (data: any) => {
        setLoading(true);

        if (!captchaStatus || !captchaToken) {
            toast.warning("Please complete the CAPTCHA verification.");
            setLoading(false);
            return;
        }

        try {
            const response = await EnquiryDemoDetails(data);
            if (response.success) {
                setSubmitted(true);
                toast.success("Thank you for contacting us! We'll get back to you within 24 hours.");
                reset();
                setCaptchaStatus(false);
                setToken('');
                recaptchaRef.current?.reset();
                if (onFormFinish) onFormFinish();
            } else {
                toast.error('Failed to submit inquiry. Please try again.');
            }
        } catch (error) {
            toast.error('An error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    const onChange = (value: any) => {
        setToken(value);
        setCaptchaStatus(true)
    }

    return (<>

        <Card className="shadow-lg border-0 rounded-3 contact-form-card">
            <Card.Body className="p-4">
                {!submitted ? (
                    <>
                        <div className=" mb-4">
                            {/* <div className="contact-icon bg-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
                                <FeatherIcon icon="message-circle" size={24} className="text-white" />
                            </div> */}
                            <h4 className="fw-bold  mb-2">Let's Talk Further</h4>
                            <p className="text-muted mb-0">Please fill out the following form and we will get back to you shortly

                            </p>
                        </div>

                        <form onSubmit={handleSubmit(onSubmit)} className="contact-form">
                            <Row>
                                <Col lg={12}>
                                    <FormInput
                                        type="text"
                                        name="ComName"
                                        label="Company Name"
                                        placeholder="Enter Company Name"
                                        containerClass={'mb-3'}
                                        register={register}
                                        errors={errors}
                                        control={control}
                                    />
                                </Col>

                                <Col md={6}>
                                    <FormInput
                                        type="text"
                                        name="fname"
                                        label="First Name"
                                        placeholder="Your First Name"
                                        containerClass={'mb-3'}
                                        register={register}
                                        errors={errors}
                                        control={control}
                                    />
                                </Col>
                                <Col md={6}>
                                    <FormInput
                                        type="text"
                                        name="lname"
                                        label="Last Name"
                                        placeholder="Your Last Name"
                                        containerClass={'mb-3'}
                                        register={register}
                                        errors={errors}
                                        control={control}
                                    />
                                </Col>

                                <Col lg={12}>
                                    <FormInput
                                        type="email"
                                        name="email"
                                        label="Email Address"
                                        placeholder="Your Email "
                                        containerClass={'mb-3'}
                                        register={register}
                                        errors={errors}
                                        control={control}
                                    />
                                </Col>

                                <Col lg={12}>
                                    <FormInput
                                        type="tel"
                                        name="Cnumber"
                                        label="Contact Number"
                                        maxLength={10}
                                        placeholder="Your Contact Number"
                                        containerClass={'mb-3'}
                                        register={register}
                                        errors={errors}
                                        control={control}
                                    />
                                </Col>

                                <Col lg={12}>
                                    <FormInput
                                        type="textarea"
                                        name="message"
                                        label="Your Message"
                                        placeholder="Type Your Message..."
                                        rows={4}
                                        containerClass={'mb-4'}
                                        register={register}
                                        errors={errors}
                                        control={control}
                                    />
                                </Col>

                                <Col lg={12}>
                                    {/* <div className="mb-4">
                                        <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey="6Lchm_4qAAAAAGOEl-D9UqjqMyFAAuYFvORjkwmw"
                                            onChange={onChange}
                                        />
                                    </div> */}

                                    <div className="recaptcha-container">
                                        <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey="6Lchm_4qAAAAAGOEl-D9UqjqMyFAAuYFvORjkwmw"
                                            onChange={onChange}
                                        />
                                    </div>

                                    {/* <Button
                                        type="submit"
                                        className="w-100 py-2 fw-semibold submit-btn"
                                        disabled={loading}
                                        size="lg"
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" />
                                                Sending Message...
                                            </>
                                        ) : (
                                            <>
                                                Send Message
                                                <FeatherIcon icon="send" className="ms-2" size={16} />
                                            </>
                                        )}
                                    </Button> */}
                                    <Button type="submit" style={{ marginTop: 12, backgroundColor: colors.primary.teal }} disabled={loading}>
                                        {loading ? (
                                            <div className="spinner-border spinner-border-sm text-white" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        ) : (
                                            'Send'
                                        )}

                                    </Button>
                                </Col>
                            </Row>
                        </form>
                    </>
                ) : (
                    <div className="text-center p-4 success-state">
                        <div className="success-icon bg-success rounded-circle d-inline-flex align-items-center justify-content-center mb-3">
                            <FeatherIcon icon="check-circle" size={32} className="text-success" />
                        </div>
                        <h4 className="text-success fw-bold mb-3">Thank You!</h4>
                        <p className="text-muted mb-4">
                            Your information has been successfully submitted. <br />
                            Someone from our team will contact you within 24 hours.
                        </p>

                    </div>




                )}
            </Card.Body>

            <style>{`
                .contact-form-card {
                    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
                    border: 1px solid #e9ecef !important;
                }
                
                .contact-icon {
                    width: 60px;
                    height: 60px;
                    background: linear-gradient(135deg, #4a6cf7 0%, #6a11cb 100%) !important;
                }
                
                .success-icon {
                    width: 80px;
                    height: 80px;
                    background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
                }
                
                .submit-btn {
               
                    border: none;
                    border-radius: 8px;
                    transition: all 0.3s ease;
                }
                
                .submit-btn:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 15px rgba(74, 108, 247, 0.4);
                }
                
                .submit-btn:disabled {
                    opacity: 0.7;
                }
                
                .form-control {
                    border-radius: 8px;
                    border: 1px solid #e1e5e9;
                    padding: 12px 16px;
                    transition: all 0.3s ease;
                }
                
                .form-control:focus {
                    border-color: #4a6cf7;
                    box-shadow: 0 0 0 0.2rem rgba(74, 108, 247, 0.25);
                }
                
                .form-label {
                    font-weight: 600;
                    color: #2d3748;
                    margin-bottom: 8px;
                }
                
                .success-state {
                    background: linear-gradient(135deg, #f8fff9 0%, #f0f9ff 100%);
                    border-radius: 12px;
                }
            `}</style>
        </Card>

        <style>{`
               .recaptcha-container {
  transform: scale(1);
  transform-origin: 0 0;
}

/* Tablet */
@media (max-width: 768px) {
  .recaptcha-container {
    transform: scale(0.9);
  }
}

/* Mobile */
@media (max-width: 480px) {
  .recaptcha-container {
    transform: scale(0.8);
  }
}
            `}</style>

    </>
    );
};

export default ContactForm;